import { Builder } from "@builder.io/react";
import Clients from ".";

const HomeClients = () => <Clients />;
Builder.registerComponent(HomeClients, {
    name: "HomeClients",
});
